import '@/i18n/config.ts';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import App from './App.tsx';
import SubscribeTrade from './components/SubscribeTrade.tsx';
import { ErudaProvider } from './components/edura/index.tsx';
import { Toaster } from './components/toast-message/sonner.tsx';
import Version from './components/version/version.tsx';
import { Container } from './container.tsx';
import './index.css';
import MiniKitProvider from './minikit-provider.tsx';
import { SubscribePrice } from './provider/SubscribePrice.tsx';
import { AuthProvider } from './provider/auth-provider.tsx';
import { PopupRandom } from './components/popups/popup-random.tsx';

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        {/* <RegionBlocked> */}
            <ErudaProvider>
                <BrowserRouter>
                    <MiniKitProvider>
                        <Container>
                            <AuthProvider>
                                <App />
                                <SubscribePrice />
                                <SubscribeTrade />
                                <Version />
                                <Toaster position="top-center" />

                                <PopupRandom />
                            </AuthProvider>
                        </Container>
                    </MiniKitProvider>
                </BrowserRouter>
            </ErudaProvider>
        {/* </RegionBlocked> */}
    </StrictMode>
);
